import React from 'react';
import { CheckCircle2Icon, InfoIcon } from 'lucide-react';
import { SectionHeading } from '../SectionHeading';
import { SectionCTA } from '../SectionCTA';
import { volumes } from '../../data/volumes';
import { getIcon } from '../../utils/icons';
export function Volumes() {
  return <section className="bg-paper px-4 py-16 sm:py-24" aria-labelledby="volumes-title" data-id="element-367" data-mp="2szyc2sm38pbc">
      <div className="mx-auto max-w-5xl" data-id="element-368" data-mp="2o0lhfloz6dy7">
        <SectionHeading eyebrow="Inside the collection" title={<span id="volumes-title" data-id="element-370" data-mp="2j9d5oj06aghv">What will you find inside the Critical Care Nursing Blueprint™?</span>} subtitle="Six structured volumes, each focused on a different area of critical care nursing education." data-id="element-369" data-mp="2o1ddexmhidp0" />

        <div className="mt-12 space-y-6" data-id="element-371" data-mp="29d0cdm8ji4nn">
          {volumes.map(v => {
          const Icon = getIcon(v.icon);
          return <article key={v.number} className="overflow-hidden rounded-3xl bg-white shadow-[0_1px_2px_rgba(6,18,41,0.06)] ring-1 ring-navy-900/5" data-id="element-372" data-mp="25bx2rhh354uv">
                <div className="flex items-center gap-3 px-5 py-3 text-white sm:px-8" style={{
              backgroundColor: v.color
            }} data-id="element-373" data-mp="333t53mxb7lae">
                  <Icon className="h-5 w-5" strokeWidth={2.5} aria-hidden="true" data-id="element-374" data-mp="2u5hirx3h79nr" />
                  <span className="text-sm font-black uppercase tracking-widest" data-id="element-375" data-mp="2y6ja7rr5ihf6">Volume {v.number}</span>
                </div>
                <div className="p-5 sm:p-8" data-id="element-376" data-mp="3lvvsri8dc1u5">
                  <h3 className="text-2xl font-black leading-tight text-ink text-balance sm:text-3xl" data-id="element-377" data-mp="3lu153w5ppvmd">{v.title}</h3>
                  <p className="mt-2 text-base font-bold sm:text-lg" style={{
                color: v.color
              }} data-id="element-378" data-mp="3qsugnj1fvcjw">
                    {v.tagline}
                  </p>
                  <p className="mt-4 text-[15px] leading-relaxed text-muted sm:text-base" data-id="element-379" data-mp="3ht7gt1ocyesy">{v.intro}</p>

                  <h4 className="mt-6 text-sm font-extrabold uppercase tracking-wider text-ink" data-id="element-380" data-mp="21fhcbttbtois">
                    Inside Volume {v.number}
                  </h4>
                  <ul className="mt-3 grid gap-x-6 gap-y-2.5 sm:grid-cols-2" data-id="element-381" data-mp="bzogq0ulv14c">
                    {v.inside.map(item => <li key={item} className="flex items-start gap-2.5" data-id="element-382" data-mp="713j896qmvjl">
                        <CheckCircle2Icon className="mt-0.5 h-5 w-5 shrink-0" style={{
                    color: v.color
                  }} aria-hidden="true" data-id="element-383" data-mp="28trqopz5nf7" />
                        <span className="text-[15px] leading-snug text-ink" data-id="element-384" data-mp="3peuiiw05tblv">{item}</span>
                      </li>)}
                  </ul>

                  <div className="mt-6 rounded-2xl bg-navy-950 p-4 sm:p-5" data-id="element-385" data-mp="3fflqw9sro92o">
                    <p className="text-xs font-black uppercase tracking-wider text-cta" data-id="element-386" data-mp="3fhortovgjmm6">Your takeaway</p>
                    <p className="mt-1.5 text-[15px] font-medium leading-relaxed text-white sm:text-base" data-id="element-387" data-mp="1doihfnum50jp">
                      {v.takeaway}
                    </p>
                  </div>

                  {v.note && <p className="mt-4 flex items-start gap-2 text-sm leading-relaxed text-muted" data-id="element-388" data-mp="2rl203lluykoq">
                      <InfoIcon className="mt-0.5 h-4 w-4 shrink-0" aria-hidden="true" data-id="element-389" data-mp="2wj3evuc93xue" />
                      {v.note}
                    </p>}
                </div>
              </article>;
        })}
        </div>

        <SectionCTA label="Yes! I want all 6 volumes" note="One-time payment of $27 USD · Instant digital access" data-id="element-390" data-mp="35b5exrierc45" />
      </div>
    </section>;
}